import { ImportEntityTypeModel } from '@utmost.co/enterprise-models';

/**
 * List of URNs that support reference entity searches. There are two kinds of searches:
 *
 * 1: reference entity validation, eg. I'm importing a list of WORKERS and referencing a classification for some of them,
 *    please highlight cells for which I have referenced non-existant classification
 * 2: reference entity existence, eg. I'm importing a list of JOB FAMILIES each with a unique reference Id,
 *    please highlight cells according to whether the reference Id does not exist (create operation) does exist (update operation)
 *
 */

export const supportedURNsForReferenceIdValidations = [
  'urn:utmost:*:engagement:fields:workerClassification',
  'urn:utmost:*:engagement:fields:jobProfile',
  'urn:utmost:*:engagement:fields:costCenters',
  'urn:utmost:*:engagement:fields:primaryOrg',
  'urn:utmost:*:engagement:fields:company',
  'urn:utmost:*:engagement:fields:businessSite',
  'urn:utmost:*:engagement:fields:jobFamily',
  'urn:utmost:*:engagement:fields:supplier',
  'urn:utmost:*:engagement:fields:holidaySchedule',
  'urn:utmost:*:engagement:fields:workSchedule',
  'urn:utmost:*:engagement:fields:msp',
  'urn:utmost:*:person:fields:uid',
  'urn:utmost:*:supplier:fields:parentSupplier',
  'urn:utmost:*:supplier:fields:msp',
  'urn:utmost:*:ratecard:fields:supplier',
  'urn:utmost:*:ratecard:fields:jobProfile',
  'urn:utmost:*:jobfamily:fields:jobFamilyGroup',
  'urn:utmost:*:jobprofile:fields:jobFamily',
  'urn:utmost:*:jobprofile:fields:mappedExportJobProfile',
  'urn:utmost:*:expense:fields:supplier',
  'urn:utmost:*:expense:fields:person',
  'urn:utmost:*:expense:fields:costCenter',
  'urn:utmost:*:expense:fields:expenseCategory',
  'urn:utmost:*:org:fields:parentOrg',
  'urn:utmost:*:org:fields:manager',
  'urn:utmost:*:org:fields:location',
  'urn:utmost:*:location:fields:parent',
  'urn:utmost:*:expense:fields:semanticVersion',
  'urn:utmost:*:contract:fields:parentContract',
  'urn:utmost:*:contract:fields:costCenter',
  'urn:utmost:*:contract:fields:businessSite',
  'urn:utmost:*:contract:fields:company',
  'urn:utmost:*:contract:fields:holidaySchedule',
  'urn:utmost:*:contract:fields:workSchedule',
  'urn:utmost:*:contract:fields:accountablePerson',
  'urn:utmost:*:customobject:fields:customFieldDefinition',
  'urn:utmost:*:jobapplication:fields:jobRequest'
];

export const supportedURNsForEntityExistsByReferenceId = new Set([
  'urn:utmost:*:classification:fields:referenceId',
  'urn:utmost:*:jobprofile:fields:referenceId',
  'urn:utmost:*:person:fields:companyWorkerId',
  'urn:utmost:*:costcenter:fields:referenceId',
  'urn:utmost:*:org:fields:referenceId',
  'urn:utmost:*:supplier:fields:referenceId',
  'urn:utmost:*:company:fields:referenceId',
  'urn:utmost:*:businesssite:fields:referenceId',
  'urn:utmost:*:jobfamily:fields:referenceId',
  'urn:utmost:*:jobfamilygroup:fields:referenceId'
]);

export const isExtensionRegexp = new RegExp('^urn:utmost:([a-z]+|\\*):[a-z]+:extensions:(.*)$');
export const NULL_FIELD_VALUE = '#null';

export const importTypeToEntityURNs: Map<ImportEntityTypeModel, string[]> = new Map([
  ['WORKER', ['urn:utmost:*:person', 'urn:utmost:*:engagement']],
  ['COST_CENTER', ['urn:utmost:*:costcenter']],
  ['SUPPLIER', ['urn:utmost:*:supplier']],
  ['RATE_CARD', ['urn:utmost:*:ratecard']],
  ['TIMESHEET', ['urn:utmost:*:timesheet']],
  ['EXPENSE', ['urn:utmost:*:expense']]
]);
